import { Space, message } from 'antd';
import moment, { Moment } from 'moment';
import { useEffect } from 'react';

import { Button, Form, FormItemDatePicker } from '../../../components/index';
import {
  createDateString,
  createDateStringPtBr,
  disabledDateAfterToday,
} from '../../../utils/utils';
import { BaseActionModalProps } from './staymentActions';

type EndUndockingModalProps = BaseActionModalProps & {
  onEndUndocking: () => void;
};

export function EndUndockingModal(props: EndUndockingModalProps) {
  const {
    setIsVisible,
    onEndUndocking,
    updateDocking,
    currentDocking,
    isLoadingUpdateDocking,
  } = props;
  const [form] = Form.useForm();

  function validate(firstCableUntiedIn: string, lastCableUntiedIn: Moment) {
    const firstCableUntiedInMoment = moment(firstCableUntiedIn);
    if (lastCableUntiedIn <= firstCableUntiedInMoment) {
      message.error(
        `A data do último cabo desamarrado não pode ser menor que a data do primeiro cabo desamarrado(${createDateStringPtBr(
          firstCableUntiedInMoment
        )})`
      );
      return false;
    }
    return true;
  }

  function handleFormSubmit() {
    form.validateFields().then(async (values) => {
      if (updateDocking) {
        if (
          !validate(
            currentDocking?.first_cable_untied_in || '',
            values.last_cable_untied_in
          )
        )
          return;

        updateDocking(
          {
            ...values,
            last_cable_untied_in: createDateString(values.last_cable_untied_in),
            id: currentDocking?.id,
          },
          onEndUndocking
        );
      }
    });
  }
  useEffect(() => {
    if (currentDocking) {
      form.setFieldsValue({
        last_cable_untied_in: currentDocking?.last_cable_untied_in,
      });
    }
  }, [currentDocking]);
  return (
    <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
      <FormItemDatePicker
        name="last_cable_untied_in"
        label="Último cabo desamarrado em:"
        disabledDate={disabledDateAfterToday}
        colSpan={12}
        tooltip=""
        rules={[
          {
            required: true,
            message:
              'Por favor, preencha a data e hora do último cabo desamarrado',
          },
        ]}
      />
      <Space
        size={12}
        style={{
          justifyContent: 'flex-end',
          display: 'flex',
          marginTop: '20px',
        }}
      >
        <Button type="text" onClick={() => setIsVisible(false)}>
          Cancelar
        </Button>
        <Button
          type="primary"
          // onClick={() => onEndUndocking()}
          htmlType="submit"
          loading={isLoadingUpdateDocking}
        >
          Finalizar desatracação
        </Button>
      </Space>
    </Form>
  );
}
